<template>
    <div class="large-8 columns content__column">
        <h2>Registrering - Ny bruker</h2>
        <p>Velg et brukernavn og et passord med minst 6 tegn.</p>

        <div class="form__errors" v-if="postErrors != null">
            Det oppstod en feil ved registeringen.
            <ul>
                <template v-for="fieldErrors in postErrors">
                    <template v-for="error in fieldErrors">
                        <li>
                            {{ error }}
                        </li>
                    </template>
                </template>
            </ul>
        </div>

        <div class="row form">
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    Brukernavn <span class="form__required">*</span>
                    <input type="text" name="name" maxlength="255" required autofocus v-model="caller.username" v-validate="'required|min:3'" data-vv-as="Brukernavn">
                    <span v-show="errors.has('name')" class="form__field__error">{{ errors.first('name') }}</span>
                </label>
            </div>
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    Passord <span class="form__required">*</span>
                    <input type="text" name="password" maxlength="255" required v-model="caller.password" v-validate="'required|min:6'" data-vv-as="Passord" ref="password">
                    <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
                </label>
            </div>
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    Gjenta passord <span class="form__required">*</span>
                    <input type="text" name="passwordConfirm" maxlength="255" required v-model="passwordConfirm" v-validate="'required|confirmed:password'" data-vv-as="Passord">
                    <span v-show="errors.has('passwordConfirm')" class="form__field__error">{{ errors.first('passwordConfirm') }}</span>
                </label>
            </div>
            <p class="small-12 medium-7 columns">
                Her kan du frivillig oppgi e-postadressen din. Dersom du oppgir din e-postadresse, kan du få tilsendt passord og brukernavn om du glemmer dem:
            </p>
            <div class="form__field small-12 medium-7 columns">
                <label class="form__label">
                    E-postadresse
                    <input type="text" name="email" maxlength="255" v-model="caller.email" v-validate="'email'" data-vv-as="E-postadresse">
                    <span v-show="errors.has('email')" class="form__field__error">{{ errors.first('email') }}</span>
                </label>
            </div>
            <p class="small-12 columns">
                <strong>NB! Vi sender ikke svar på SOS-meldinger til din e-postadresse.</strong><br>
                Du må logge deg inn hos oss for å lese svarene på SOS-meldingene dine.
            </p>
            <div class="form__submit small-12 medium-7 columns">
                <button @click.prevent="register" class="button form__submit__button">Register</button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data () {
    return {
        caller: {
            username: '',
            password: '',
            email:'',
        },
        passwordConfirm: '',
        postErrors:null,
        }
    },
    methods: {
        register() {
            var _this = this;
            this.$validator.validateAll().then(isValid => {
                if(isValid) {

                    // register
                    _this.$http({ method: 'post',url: '/caller/register', data : _this.caller })
                        .then(function (response) {

                            // success
                            if(response && response.data) {

                                // login
                                _this.$auth.login({
                                    url : '/caller/login',
                                    data: {
                                        username: _this.caller.username,
                                        password: _this.caller.password
                                    },
                                    success: function (response) {
                                    },
                                    error: function (response) {
                                    },
                                    rememberMe: true,
                                    redirect: '/',
                                    fetchUser: true,
                                });
                            }
                        })
                        .catch(function (error) {
                            // console.log(error.response);
                            if(error.response && error.response.data) {
                                var data = error.response.data;
                                // console.log(data);
                                _this.postErrors = data;
                            }
                        });
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue